import styled from "styled-components";

export const CMContent = styled.div((props) => ({
  "& h3": {
    [`@media (min-width: 2000px)`]: {
      fontSize:"3vh",
    },
  },
  "& p": {
    [`@media (min-width: 2000px)`]: {
      fontSize:"2.5vh",
    },
  },
}));

export const CMMentionsCarousel = styled.div((props) => ({
  display: "grid",
  gap: "16px",
  gridAutoFlow: "column",
  gridTemplateRows: "repeat(2,minmax(0,1fr))",
  padding: "3px",
  maxWidth: "100%",
  overflowX: "auto",
  overflowY: "hidden",

  "& > div": {
    width: "360px",
    display: "flex",
    borderRadius: "5px",
    boxShadow:
      "0 0.93px 0.93px rgba(0,0,0,.12), 0 0 0 0.47px rgba(64,68,82,.16), 0 1.86px 4.65px rgba(64,68,82,.08)",
    
    [`@media (min-width: 2000px)`]: {
      width: "50vh",
      height: "10vh",
    },

    "& .mention-thumbnail": {
      marginLeft: "10px",
      [`@media (min-width: 2000px)`]: {
         marginRight: "2vh"
      },
      "& img": {
        width: "96px",
        height: "100%",
        objectFit: "contain",
        [`@media (min-width: 2000px)`]: {
          width: "20vh",
          height: "10vh",
        },
      },
    },

    "& .mention-content": {
      padding: "8px 1rem",
      fontFamily: "Inter, sans-serif",

      "& .date": {
        display: "block",
        marginBottom: "8px",
        fontSize: props.theme.fontSizes.caption,
        color: "#a5aaaf",
        [`@media (min-width: 2000px)`]: {
          fontSize:"1.5vh"
        },
      },

      "& .description": {
        fontSize: "14px",
        color: "#515151",
       

        "& a": {
          textDecoration: "unset",

          "&:hover": {
            textDecoration: "underline",
          },
        }, 
        [`@media (min-width: 2000px)`]: {
          fontSize:"1.5vh"
        },
      },
    },
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    gridTemplateRows: "repeat(5,minmax(0,1fr))",
  },
  [`@media ${props.theme.breakpoints.sm}`]: {
    gridTemplateRows: "repeat(5,minmax(0,1fr))",
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    gridTemplateRows: "repeat(5,minmax(0,1fr))",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    gridTemplateRows: "repeat(5,minmax(0,1fr))",
  },
}));

export const CMSelect = styled.select`
  width: 100%;
  min-width: 100px;
  max-width: 200px;
  height: 31px
  border-radius: 4px;
  background-color: #fff;
  color: #000; 
  font-size: 1rem; 
  font-weight: 400; 
  margin-top:20px;
  margin-bottom:20px;

  & > option[value=""][disabled] {
    color: #888; 
  }

  & > option {
    color: #000; 
  }

  &::-ms-expand {
    display: none; 
  }

  &:focus {
    outline: none;
  }
`;
